import type { JsonFilter } from '@/hooks/use-table-filter/types';
import type { Invoice } from '@pigello/pigello-matrix';
import { DateTime } from 'luxon';

export const getPendingAutogiroTransactionAttemptsFilters =
  (): JsonFilter<Invoice> => ({
    autogiro_enabled: { noop: true },
    has_failed_autogiro_payment: { noop: false },
    has_successful_autogiro_payment: { noop: false },
    has_delivered_autogiro_payment: { noop: true },
    attested_date: { __isnull: false },
    due_date: {
      __gte: DateTime.now().minus({ days: 15 }).toISODate(),
    },
    closed_time: { __isnull: true },
  });
